import { Link as RouterLink } from 'react-router-dom';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  Grid,
  Stack,
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import PeopleIcon from '@mui/icons-material/People';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BarChartIcon from '@mui/icons-material/BarChart';

const dashboardLinks = [
  {
    label: 'Sales',
    to: '/sales',
    icon: <ShoppingCartIcon fontSize="large" color="primary" />,
    stat: '$10,000',
  },
  {
    label: 'Products',
    to: '/products',
    icon: <Inventory2Icon fontSize="large" color="secondary" />,
    stat: '150',
  },
  {
    label: 'Customers',
    to: '/customers',
    icon: <PeopleIcon fontSize="large" color="info" />,
    stat: '120',
  },
  {
    label: 'Expenses',
    to: '/expenses',
    icon: <ReceiptLongIcon fontSize="large" color="error" />,
    stat: '130',
  },
  {
    label: 'Transactions',
    to: '/transactions',
    icon: <AccountBalanceWalletIcon fontSize="large" color="success" />,
    stat: '130',
  },
  {
    label: 'Profit Reports',
    to: '/profit-reports',
    icon: <BarChartIcon fontSize="large" color="warning" />,
    stat: '120',
  },
];

const Dashboard = () => {
  return (
    <Layout>
      <PageHeader title="Dashboard" subtitle="Overview of your POS system." />
      <Box sx={{ p: 4 }}>
        <Typography variant="h3" fontWeight="bold" gutterBottom align="center" color="primary.main">
          POS Dashboard
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          {dashboardLinks.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.label}>
              <Card elevation={3} sx={{ borderRadius: 3, transition: '0.2s', '&:hover': { boxShadow: 8, transform: 'translateY(-4px)' } }}>
                <CardActionArea component={RouterLink} to={item.to} sx={{ p: 3 }}>
                  <Stack alignItems="center" spacing={2}>
                    {item.icon}
                    <Typography variant="h6" fontWeight="bold">{item.label}</Typography>
                    <Typography variant="h5" color="text.secondary">{item.stat}</Typography>
                  </Stack>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Layout>
  );
};

export default Dashboard;
